export default {"src":"/_next/static/media/something-else-challenge.ea799a51.svg","height":30,"width":30,"blurWidth":0,"blurHeight":0};